import { useContext } from 'react'
import { UserEmailContext } from '../contexts/userEmailContext'

const useUserEmail = () => {
  return useContext(UserEmailContext)
}

export default useUserEmail
